import { withLoadingTypes as withCargoTypes } from '@ati/hocs';
import OptionsSelector from '@components/options-selector';
import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { useStore } from 'hooks/useStore';

import css from './Mobile.module.css';

const WrappedOptionsSelector = withCargoTypes(OptionsSelector);

const Mobile = () => {
  const {
    dictionaries: { data },
    app: { i18n },
    filter: {
      loadingType: { loadingTypes, clearLoadingTypes, setLoadingTypes, isDefault },
    },
  } = useStore();

  const actions = {
    second: {
      onClick: clearLoadingTypes,
      text: i18n.common.reset,
    },
  };

  const handleChange = (values: string[]) => {
    setLoadingTypes(values);
  };

  return (
    <MobileScreen hasBackButton actions={!isDefault ? actions : undefined} title={i18n.loadingTypes.label}>
      <WrappedOptionsSelector
        classNames={{ desktopOptionList: css.list }}
        /* @ts-ignore */
        dictionary={data.loadingTypes}
        matchMedia="1px"
        selectedValues={loadingTypes}
        /* @ts-ignore */
        onChange={handleChange}
      />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
